/* unplugin-vue-components disabled */import { render } from "./TradeDetail.vue?vue&type=template&id=e8d365f0&scoped=true"
import script from "./TradeDetail.vue?vue&type=script&lang=js"
export * from "./TradeDetail.vue?vue&type=script&lang=js"

import "./TradeDetail.vue?vue&type=style&index=0&id=e8d365f0&lang=less&scoped=true"

import exportComponent from "D:\\源码\\frontend\\vue-wms-mobile-3\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e8d365f0"]])

export default __exports__